import { Color } from '@billy/design-system'

import { GraphBarType } from '../../../enums/graphBarType'
import { BarColors } from '../types/barColors'

export const barColors: BarColors = {
  default: {
    [GraphBarType.Paid]: Color.Green300,
    [GraphBarType.Unpaid]: Color.Grey150,
  },
  hovered: {
    [GraphBarType.Paid]: Color.Green700,
    [GraphBarType.Unpaid]: Color.Grey200,
  },
}
